import { useContext } from 'react';

import { CategoricalBarChartDataContext } from '../contexts/CategoricalBarChartDataContext.js';

export const useCategoricalBarChartData = () =>
  useContext(CategoricalBarChartDataContext);
